module.exports = __webpack_public_path__ + "static/media/PA-Icon-Kirche-pos.f26275ae.svg";